<template>
  <!--
  - Display an error if there's an error loading objects
   -->
  <mp-alert-error v-if="errors.length > 0" :errors="errors">
    There was one or more errors loading Clips
  </mp-alert-error>

  <div v-else>
    <!--
    - Otherwise display a table of objects
     -->
    <mp-data-table
      :sort="table.sort"
      :total-results="table.totalResults"
      :headers="headers"
      :offset="table.offset"
      :filters="table.filters"
      :loading="loading"
      @state-changed="onStateChange"
    >
      <!--
      - Loop through all objects returned
      -->
      <tr v-for="clip in clips" :key="clip.id()">
        <td>{{ clip.id() }}</td>
        <td>{{ clip.get("recordingName") }}</td>
        <td>{{ clip.get("statusLabel") }}</td>
        <td>{{ clip.getDate("dateClipStarted") | date }}</td>
        <td>{{ clip.get("duration") }}s</td>

        <!--
        - Display a collections of actions for this object
        -->
        <td class="action">
          <mp-action-dropdown>
            <mp-action-dropdown-item icon="edit" @click="viewClip(clip)">
              View Clip
            </mp-action-dropdown-item>
          </mp-action-dropdown>
        </td>
      </tr>
    </mp-data-table>
  </div>
</template>

<script>
import { API } from "@memberpoint/mp-frontend-core";
import { ClipManager } from "../Manager/ClipManager";
import fnsFormat from "date-fns/format";
import Filters from "../Lib/Filters";
import DataTableFilters from "@/VueResources/Mixins/DataTableFilters";

export default {
  name: "ClipsClipList",
  filters: {
    date(date) {
      if (date instanceof Date) {
        return fnsFormat(date, "Pp");
      } else {
        return "-";
      }
    }
  },
  mixins: [DataTableFilters],
  data() {
    return {
      errors: [],
      loading: true,
      clips: [],
      table: {
        /**
         *@type {APIUrlBuilder|null}
         */
        builder: null,
        totalResults: 0,
        filters: Filters,
        offset: 0,
        sort: { start_datetime: "desc" }
      },
      headers: [
        { name: "id", title: "Clip ID", sortable: false },
        { name: "name", title: "Recording Name", sortable: true },
        { name: "status", title: "Status", sortable: true },
        {
          name: "dateClipStarted",
          title: "Start Time",
          sortable: true
        },
        { name: "duration", title: "Duration" },
        { name: "", title: "" }
      ]
    };
  },
  created() {
    this.table.filters = this.parseFiltersFromUrl(
      this.table.filters
    ).getFilters();
  },
  methods: {
    /**
     * Load up a list of all recordings
     */
    load() {
      this.loading = true;
      let manager = new ClipManager();
      manager
        .getClips(this.table.builder)
        .then(apiResponse => {
          this.clips = apiResponse.getData();
          this.table.totalResults = apiResponse.getTotalResults();
        })
        .catch(err => {
          this.errors = API.SimpleAPIErrorParser.parse(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onStateChange(event) {
      if (event.getStateChangeType() !== "row-selection") {
        // update the url route with filters.
        this.DataTableFiltersRouterUpdate(event.getFilters());

        // update the url builder instance
        this.table.builder = this.buildUrlBuilderFromDataTableState(event);
        this.table.offset = event.getPaginationOffset();

        if (event.getStateChangeType() === "filters") {
          this.table.offset = 0;
          this.table.builder.setPagination(event.getPaginationLimit(), 0);
        }

        // re-load members.
        this.load();
      }
    },

    /**
     *
     * @param {SimpleAPIData} object
     */
    editObject(object) {
      this.edit = {
        show: true,
        id: object.id()
      };
    },
    viewClip(object) {}
  }
};
</script>

<style scoped lang="scss">
.action {
  max-width: 50px;
  text-align: right;
}
.status {
  width: 60px;
  text-align: center;
}
</style>
